import { Text, Icons, Stack, Grid, PureTextButton, Card } from '@/theme/index';
import { PossibleBrandItem } from './allPossibleBrands';

type BrandItemFound = {
  found: boolean;
} & PossibleBrandItem;

interface BrandsProps {
  handleClickPossibleBrand: (option: PossibleBrandItem) => void;
  allBrandsFlagged: BrandItemFound[];
}

export const AllTitleBrands = ({
  handleClickPossibleBrand,
  allBrandsFlagged,
}: BrandsProps) => {
  const reserializeOptionsData = allBrandsFlagged.map((option, index) => (
    <Grid item lg={4} md={4} sm={4} xs={12} key={index}>
      <Stack direction="row" alignItems="center">
        {option.found ? (
          <Icons.Warning
            color="error"
            fontSize="small"
            sx={{ marginRight: 1, fontSize: '0.9rem' }}
          />
        ) : (
          <Icons.Check
            color="primary"
            fontSize="small"
            sx={{ marginRight: 1, fontSize: '0.9rem' }}
          />
        )}
        <PureTextButton
          variant="text"
          color={option.found ? 'error' : 'success'}
          onClick={() => handleClickPossibleBrand(option)}
          sx={{ fontSize: '0.9rem' }}
        >
          {option.name}
        </PureTextButton>
      </Stack>
    </Grid>
  ));

  return (
    <Card variant="outlined">
      <Text variant="h3" data-testid="all-title-brands-title">
        The following are all possible checks perform on this vehicle
      </Text>
      <Stack direction="row">
        <Icons.Info fontSize="small" color="primary" />
        <Text
          data-testid="all-title-brands-description"
          variant="body1"
          textAlign="initial"
          ml={1}
        >
          Click the brand to view more information
        </Text>
      </Stack>
      <Text
        data-testid="all-title-brands-source"
        mt={2}
        sx={{
          color: (theme) => theme.palette.text.secondary,
          fontSize: '0.75rem',
          fontWeight: 'bold',
        }}
      >
        Source: NMVTIS
      </Text>
      {Boolean(reserializeOptionsData.length) && (
        <Grid container>{reserializeOptionsData}</Grid>
      )}
    </Card>
  );
};
